import { MessagingTopology } from '@internal/open-catalog';
import { Button, createStyles, ListItemIcon, makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@mui/material';
import React from 'react';
import { downloadJsonAsFile } from '../../../../../../components/file';
import { exportToRabbitMQ } from './rabbitmq.exporter';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      paddingLeft: theme.spacing(1),
      textTransform: 'capitalize'
    }
  })
);

export const ButtonExportTopology = (props: { topology: MessagingTopology, suffix?: string }) => {

  const { topology, suffix } = props;

  const classes = useStyles();

  const handleExport = () => {
    downloadJsonAsFile(`${topology.channelName}${suffix ? `-${suffix}` : ''}`, exportToRabbitMQ(topology, suffix));
  };

  return (
    <ListItemIcon>
      <Button onClick={handleExport} title="Export the topology definition to import in the local message broker instance.">
        <CloudDownloadIcon />
        <Typography className={classes.text}>Export</Typography>
      </Button>
    </ListItemIcon>
  );
}